const api = {
  url: process.env.REACT_APP_API_URL || "https://test.healthprofile.digital:8080/",
};

export default api;
